// import request from '../request';
export default {
  state: {
    message: {
      text: false,
      className: false,
    },
  },
  mutations: {
    unsetMessage(state) {
      Object.assign(state.message, { text: false });
      Object.assign(state.message, { className: false });
    },
    setMessage(state, globalMessage) {
      Object.assign(state.message, { text: globalMessage.message });
      if (typeof globalMessage.className !== 'undefined') {
        Object.assign(state.message, { className: globalMessage.className });
      }
      if (typeof globalMessage.timeout !== 'undefined') {
        setTimeout(() => {
          Object.assign(state.message, { text: false });
          Object.assign(state.message, { className: false });
        }, globalMessage.timeout);
      }
    },
  },
  actions: {
    setGlobalMessage(context, payload) {
      window.jQuery('html, body').animate({
        scrollTop: 0,
      }, 800);
      context.commit('setMessage', payload);
    },
    unsetGlobalMessage(context) {
      context.commit('unsetMessage');
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/globalMessage.js